// src/features/treinos/components/LiveWorkoutHost.jsx
//
// Host GLOBAL da sessão ao vivo — montado no root (App.jsx), irmão de AppRoutes.
// Liga o uid no provider e monta, em INSTÂNCIA ÚNICA:
//   • ModoTreino (Offcanvas placement="end") — VIEW do provider
//   • LiveWorkoutWidget — card flutuante quando minimizado
//   • RegistrarTreinoCheckin — controlado pelo provider via checkin request
//
// Parte I (handoff): o check-in vive aqui (não mais no TreinoUser). Os disparos
// (live finalizado / manual / edição) chegam pelo provider.openCheckin.

import React, { useEffect } from "react";
import { useUser } from "../../../contexts/UserContext.jsx";
import { useLiveWorkout } from "../../../contexts/LiveWorkoutContext.jsx";
import ModoTreino from "./ModoTreino.jsx";
import LiveWorkoutWidget from "./LiveWorkoutWidget.jsx";
import RegistrarTreinoCheckin from "./RegistrarTreinoCheckin.jsx";

export default function LiveWorkoutHost() {
  const { user } = useUser();
  const {
    setUid,
    checkin,
    clearEditingCheckin,
    markSaved,
  } = useLiveWorkout();

  useEffect(() => { setUid(user?.uid || null); }, [user?.uid, setUid]);

  return (
    <>
      <ModoTreino />
      <LiveWorkoutWidget />
      <RegistrarTreinoCheckin
        openTrigger={checkin.manualTrigger}
        initialPhoto={checkin.photo}
        livePrefill={checkin.livePrefill}
        livePrefillTrigger={checkin.liveTrigger}
        editingCheckin={checkin.editingCheckin}
        onCloseEdit={clearEditingCheckin}
        onSaved={markSaved}
        showFab={false}
      />
    </>
  );
}
